import React, { useState, useEffect, useRef } from "react";
import {
  Typography,
  Button,
  List,
  ListItem,
  Box,
  Container,
  CircularProgress,
  Radio,
} from "@mui/material";
import { useSnackbar } from "notistack";
import { useLocation } from "react-router-dom";
import { Helper } from "../../tools/Helper";
import { api_Routes } from "../../api_Routes";
import queryString from "query-string";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Crtypto from "../../Assets/crypto.svg";
import Payeer from "../../Assets/Payeer.png";
// import Paypal from "../../Assets/paypal.png";

const ServicesInvoice = () => {
  const location = useLocation();
  const { invoice_id } = queryString.parse(location.search);
  const baseApi = api_Routes.invoice.getOne(invoice_id);
  const [invoice, setInvoice] = useState(null);
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(true);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("");
  // const [payPalError, setPayPalError] = useState("");
  // const [paypalReady, setPaypalReady] = useState(false);
  const invoiceRef = useRef(null);

  // Fetch invoice data
  useEffect(() => {
    const getInvoice = async () => {
      try {
        const { response, message } = await Helper.Get({
          url: baseApi,
          hasToken: true,
        });

        if (response) {
          setInvoice({
            invoice_id: response.data.invoice_id,
            service_name: response.data.service_name,
            service_type_name: response.data.service_type_name,
            user_name: response.data.user_name,
            price: response.data.price,
            panel_url: response.data.panel_url,
            created_at: response.data.created_at,
            status: response.data.status,
          });
        } else {
          enqueueSnackbar(message || "Failed to load invoice", {
            variant: "error",
          });
        }
      } catch (error) {
        enqueueSnackbar("Error loading invoice", { variant: "error" });
        console.error("Error fetching invoice:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getInvoice();
  }, [baseApi, enqueueSnackbar]);

  const printInvoice = () => {
    if (!invoiceRef.current) return;
    const printContent = invoiceRef.current.innerHTML;
    const originalContent = document.body.innerHTML;
    document.body.innerHTML = printContent;
    window.print();
    document.body.innerHTML = originalContent;
  };

  const handleMethodChange = (event) => {
    setPaymentMethod(event.target.value);
    // setPayPalError("");
  };

  // const createPayPalOrder = async (data, actions) => {
  //   try {
  //     setIsProcessingPayment(true);
  //     console.log("Creating PayPal order for invoice:", invoice_id);
  //
  //     return actions.order.create({
  //       purchase_units: [{
  //         amount: {
  //           value: invoice?.price || "0.00",
  //           currency_code: "USD",
  //           breakdown: {
  //             item_total: {
  //               value: invoice?.price || "0.00",
  //               currency_code: "USD"
  //             }
  //           }
  //         },
  //         invoice_id: invoice_id,
  //         items: [{
  //           name: invoice?.service_name || "Service",
  //           quantity: "1",
  //           unit_amount: {
  //             value: invoice?.price || "0.00",
  //             currency_code: "USD"
  //           }
  //         }]
  //       }],
  //       application_context: {
  //         shipping_preference: "NO_SHIPPING",
  //         user_action: "PAY_NOW"
  //       }
  //     });
  //   } catch (err) {
  //     console.error("PayPal order creation failed:", err);
  //     setPayPalError("Failed to create payment order: " + err.message);
  //     enqueueSnackbar("Payment setup failed", { variant: "error" });
  //     throw err;
  //   } finally {
  //     setIsProcessingPayment(false);
  //   }
  // };
  //
  // const onPayPalApprove = async (data, actions) => {
  //   try {
  //     setIsProcessingPayment(true);
  //     console.log("PayPal payment approved, capturing order...");
  //
  //     const details = await actions.order.capture();
  //     console.log("PayPal payment details:", details);
  //
  //     if (details.status !== "COMPLETED") {
  //       throw new Error(Payment status was ${details.status});
  //     }
  //
  //     console.log("Sending payment confirmation to backend...");
  //     const { response, message } = await Helper.Post({
  //       url: api_Routes.invoice.pay,
  //       data: {
  //         payment_method: "paypal",
  //         invoice_id: invoice_id,
  //         paypal_order_id: data.orderID,
  //         paypal_payment_details: details
  //       },
  //       hasToken: true,
  //     });
  //
  //     if (!response) {
  //       throw new Error(message || "Backend verification failed");
  //     }
  //
  //     enqueueSnackbar("Payment successful! Order completed.", { variant: "success" });
  //     // Refresh invoice data
  //     const { response: invoiceResponse } = await Helper.Get({
  //       url: baseApi,
  //       hasToken: true,
  //     });
  //     if (invoiceResponse) {
  //       setInvoice(prev => ({
  //         ...prev,
  //         status: invoiceResponse.data.status
  //       }));
  //     }
  //   } catch (err) {
  //     console.error("Payment processing failed:", err);
  //     setPayPalError("Payment failed: " + err.message);
  //     enqueueSnackbar("Payment failed: " + err.message, { variant: "error" });
  //
  //     // Attempt to void the payment if it was captured
  //     if (data.orderID) {
  //       try {
  //         console.log("Attempting to void payment...");
  //         await actions.order.void(data.orderID);
  //       } catch (voidError) {
  //         console.error("Failed to void payment:", voidError);
  //       }
  //     }
  //   } finally {
  //     setIsProcessingPayment(false);
  //   }
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!paymentMethod) {
      enqueueSnackbar("Please select a payment method.", {
        variant: "warning",
      });
      return;
    }
    // if (paymentMethod === "paypal") return;

    setIsProcessingPayment(true);
    try {
      const { response, message } = await Helper.Post({
        url: api_Routes.invoice.pay,
        data: { payment_method: paymentMethod, invoice_id },
        hasToken: true,
      });

      if (response) {
        enqueueSnackbar(message || "Payment initiated successfully", {
          variant: "success",
        });
        if (response.data) {
          window.location.href = response.data;
        }
      } else {
        throw new Error(message || "Payment initiation failed");
      }
    } catch (error) {
      enqueueSnackbar(error.message, { variant: "error" });
      console.error("Payment error:", error);
    } finally {
      setIsProcessingPayment(false);
    }
  };

  if (isLoading) {
    return (
        <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
        >
          <CircularProgress />
        </Box>
    );
  }

  if (!invoice) {
    return (
        <Container sx={{ textAlign: "center", py: 4 }}>
          <Typography variant="h6">Invoice not found</Typography>
        </Container>
    );
  }

  if (invoice.status === "PAID") {
    return (
        <Container sx={{ textAlign: "center", py: 4 }}>
          <Typography variant="h4" sx={{ mb: 2 }}>
            Invoice Already Paid
          </Typography>
          <Button variant="contained" onClick={printInvoice}>
            Print Invoice
          </Button>
        </Container>
    );
  }

  return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box
            ref={invoiceRef}
            sx={{
              bgcolor: "background.paper",
              p: { xs: 3, md: 4 },
              borderRadius: 2,
              boxShadow: 1,
            }}
        >
          {/* Invoice Header */}
          <Box sx={{ mb: 4, textAlign: "center" }}>
            <Typography variant="h4" gutterBottom>
              Order Invoice
            </Typography>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography>
                <strong>Invoice #:</strong> {invoice.invoice_id}
              </Typography>
              <Typography>
                <strong>Date:</strong> {invoice.created_at}
              </Typography>
            </Box>
          </Box>

          {/* From/To Sections */}
          <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: 4,
                mb: 4,
              }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" gutterBottom>
                From:
              </Typography>
              <Typography gutterBottom>
                <strong>BOOKSMM</strong>
              </Typography>
              <Typography>info@booksmm.com</Typography>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Typography variant="h6" gutterBottom>
                To:
              </Typography>
              <Typography gutterBottom>
                <strong>{invoice.user_name}</strong>
              </Typography>
              <Typography>
                <strong>Panel URL:</strong> {invoice.panel_url}
              </Typography>
            </Box>
          </Box>

          {/* Service Details */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Service Details
            </Typography>
            <Typography gutterBottom>
              <strong>{invoice.service_name}</strong>
            </Typography>
            <List sx={{ listStyleType: "disc", pl: 2 }}>
              <ListItem sx={{ display: "list-item", pl: 1 }}>
                {invoice.service_type_name}
              </ListItem>
            </List>
          </Box>

          {/* Price */}
          <Box
              sx={{
                bgcolor: "primary.main",
                color: "primary.contrastText",
                p: 2,
                mb: 4,
                borderRadius: 1,
                display: "flex",
                justifyContent: "space-between",
              }}
          >
            <Typography>
              <strong>Price:</strong>
            </Typography>
            <Typography>
              <strong>${invoice.price}</strong>
            </Typography>
          </Box>

          {/* Payment Methods */}
          <Box sx={{ mb: 4 }}>
            <Typography variant="h6" gutterBottom>
              Payment Methods
            </Typography>
            <Typography paragraph>
              Please select one payment method below.
            </Typography>

            <Box sx={{ mb: 3 }}>
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Radio
                    checked={paymentMethod === "cryptomus"}
                    onChange={handleMethodChange}
                    value="cryptomus"
                    color="primary"
                />
                <img
                    src={Crtypto}
                    alt="Cryptomus"
                    style={{ height: 24, marginRight: 8 }}
                />
                <Typography>Cryptomus</Typography>
              </Box>

              {/*<Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>*/}
              {/*  <Radio*/}
              {/*      checked={paymentMethod === "paypal"}*/}
              {/*      onChange={handleMethodChange}*/}
              {/*      value="paypal"*/}
              {/*      color="primary"*/}
              {/*  />*/}
              {/*  <img src={Paypal} alt="PayPal" style={{ height: 24, marginRight: 8 }} />*/}
              {/*  <Typography>PayPal</Typography>*/}
              {/*</Box>*/}

              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Radio
                    checked={paymentMethod === "payeer"}
                    onChange={handleMethodChange}
                    value="payeer"
                    color="primary"
                />
                <img
                    src={Payeer}
                    alt="Payeer"
                    style={{ height: 24, marginRight: 8 }}
                />
                <Typography>Payeer</Typography>
              </Box>
            </Box>

            {/*{payPalError && (*/}
            {/*    <Typography color="error" sx={{ mb: 2 }}>{payPalError}</Typography>*/}
            {/*)}*/}

            {/*{paymentMethod === "paypal" && (*/}
            {/*    <Box sx={{*/}
            {/*      border: "1px solid #eee",*/}
            {/*      p: 2,*/}
            {/*      borderRadius: 1,*/}
            {/*      backgroundColor: "#f9f9f9"*/}
            {/*    }}>*/}
            {/*      <Typography variant="body2" color="textSecondary" gutterBottom>*/}
            {/*        Test with PayPal Sandbox:*/}
            {/*      </Typography>*/}
            {/*      <Typography variant="caption" display="block" gutterBottom>*/}
            {/*        Email: sb-abcdef123456@business.example.com*/}
            {/*      </Typography>*/}
            {/*      <Typography variant="caption" display="block" sx={{ mb: 2 }}>*/}
            {/*        Password: test1234*/}
            {/*      </Typography>*/}

            {/*      */}
            {/*    </Box>*/}
            {/*)}*/}
          </Box>

          {/* Action Buttons */}
          <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }}>
            <Button
                variant="outlined"
                onClick={printInvoice}
                sx={{ "@media print": { display: "none" } }}
            >
              Print Invoice
            </Button>

            {paymentMethod && (
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={isProcessingPayment}
                    sx={{ "@media print": { display: "none" } }}
                >
                  {isProcessingPayment ? (
                      <>
                        <CircularProgress size={24} sx={{ mr: 1 }} />
                        Processing...
                      </>
                  ) : (
                      "Buy Now"
                  )}
                </Button>
            )}
          </Box>
        </Box>
      </Container>
  );
};

export default ServicesInvoice;
